module.exports = __webpack_public_path__ + "static/img/index_three_one.b701b1fa.png";